import {
  AdFormat,
  AdGroupCreateInput,
  AdvertiserConfigQuery,
  ChannelType,
  ContentStrategy,
  CostType,
  DailyBudgetType,
  Network,
  PriorityListQuery,
} from '../../../__generated__/graphql'
import { DEFAULT_ADGROUP_BUDGET_CAPPING_TYPE } from '../settings/budgetAndDates/adgroupBudgetDefaults'

export type AdgroupCreateFormValues = AdGroupCreateInput & {
  channels: ChannelType[]
}

export const buildBaseAdgroupCreateInput = (
  campaignId: string | number | undefined,
  advertiserConfig: AdvertiserConfigQuery['advertiser']['config'],
  priorityList: PriorityListQuery['campaign']['advertiser']['reseller']['priorities']
): AdGroupCreateInput => ({
  campaignId: campaignId ?? '',
  name: '',
  isActive: false,
  network: Network.Media,
  channelWeb: false,
  channelEmail: true,
  format: AdFormat.Native,
  costType: CostType.Cpc,
  costValue: Number(advertiserConfig.adGroup.min.cpc) || 0,
  contentStrategy: ContentStrategy.Promotional,
  redirectUrl: '',
  dailyBudget: Number(advertiserConfig.adGroup.min.dailyBudget) || 0,
  dailyBudgetType: DailyBudgetType.Fixed,
  budgetCapping: Number(advertiserConfig.adGroup.min.budgetCapping) || 0,
  budgetCappingType: DEFAULT_ADGROUP_BUDGET_CAPPING_TYPE,
  startDate: null,
  endDate: null,
  priorityId: priorityList.find((p) => p.isDefault)?.id,
})

export const buildAdgroupCreateFormInitialValues = (baseAdgroup: AdGroupCreateInput): AdgroupCreateFormValues => ({
  ...baseAdgroup,
  channels: [ChannelType.Email],
})
